module.exports = __webpack_public_path__ + "img/img38.cc4acd31.svg";